
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h6>{` `}</h6>
    <h1>{`Disclaimer`}</h1>
    <p>{`Ce simulateur de pension vous est proposé par Partena Professional en collaboration avec P&V Assurances. Le résultat de cette simulation est purement indicatif, Partena Professional décline toute responsabilité à cet égard.`}</p>
    <p>{`Bien que cet outil ait été développé avec le savoir-faire et le soin nécessaires, il ne pourra jamais remplacer un conseil personnalisé.`}</p>
    <p>{`Les dispositions de `}<u><a parentName="p" {...{
          "href": "https://www.partena-professional.be/fr/disclaimer"
        }}>{`la clause de non-responsabilité de Partena Professional`}</a></u>{` s'appliquent à cet outil.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;